import React, { Component } from "react";
import "./ArenaLabPage.css";
import ArenaLabNav from "./ArenaLabNav";
import ArenaLabNews from "./sections/ArenaLabNews";
import backgroundGif from "../../assets/images/ui/warehouse.gif";
import ArenaLabSlideshow from "./sections/ArenaLabSlideshow";
import ArenaLabTeam from "./sections/ArenaLabTeam";
import ArenaLabPublications from "./sections/ArenaLabPublications";
import ArenaLabOpportunities from "./sections/ArenaLabOpportunities";
import ArenaLabProjects from "./sections/ArenaLabProjects";
import { StyleProvider } from "../../contexts/StyleContext";

class ArenaLabPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDark: false
    };
  }

  componentDidMount() {
    const theme = localStorage.getItem("theme");
    if (theme === "dark") {
      this.setState({ isDark: true });
    } else if (theme === null) {
      // Check system preference
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      if (prefersDark) {
        this.setState({ isDark: true });
      }
    }
  }

  changeTheme = () => {
    this.setState(prevState => {
      const newTheme = !prevState.isDark ? "dark" : "light";
      localStorage.setItem("theme", newTheme);
      return { isDark: !prevState.isDark };
    });
  };

  render() {
    return (
      <div className={this.state.isDark ? "dark-mode" : null}>
        <StyleProvider
          value={{isDark: this.state.isDark, changeTheme: this.changeTheme}}
        >
          <div className="arena-lab-page">
            <ArenaLabNav />
            <div className="arena-lab-page-body">
              <div className="arena-lab-header">
                <img 
                  src={backgroundGif}
                  alt="Arena Lab Background"
                  className="arena-lab-bg-video"
                />
                <h1><span className="arena-gradient">ARENA</span> Lab</h1>
                <p className="arena-lab-subtitle">
                  <strong>A</strong>utonomous <strong>R</strong>obots and <strong>E</strong>mbodied <strong>N</strong>eural <strong>A</strong>gents Lab
                </p>
                <p className="arena-lab-description">Embodied AI and Robotics Research</p>
              </div>

              <div id="news">
                <ArenaLabNews />
              </div>
              <div id="team">
                <ArenaLabTeam />
              </div>
              <div id="publications">
                <ArenaLabPublications />
              </div>
              <div id="opportunities">
                <ArenaLabOpportunities />
              </div>
              <div id="projects">
                <ArenaLabProjects />
              </div>

              <div id="events" className="arena-lab-events-section">
                <h2>Memories of ARENA Lab</h2>
                <ArenaLabSlideshow />
              </div>
            </div>
          </div>
        </StyleProvider>
      </div>
    );
  }
}

export default ArenaLabPage;
